import { useState } from "react";
import { useFormStore } from "@/store/form-builder";
import { EmptyQuestionsModal } from "./EmptyQuestionsModal";
import { findEmptyQuestions, type EmptyQuestion } from "./findEmptyQuestions";

export function useEmptyQuestionsGuard() {
  const [issues, setIssues] = useState<EmptyQuestion[]>([]);

  const guard = (publish: () => void) => {
    const found = findEmptyQuestions(useFormStore.getState().pages);
    if (found.length > 0) setIssues(found);
    else publish();
  };

  const goToField = (issue: EmptyQuestion) => {
    const store = useFormStore.getState();
    store.setIsPreview(false);
    store.setCurrentPageIndex(issue.pageIndex);
    store.setSelectedSectionId(issue.sectionId);
    store.setSelectedQuestionId(issue.questionId);
    setIssues([]);
  };

  const dialog = (
    <EmptyQuestionsModal issues={issues} onClose={() => setIssues([])} onGoToField={goToField} />
  );

  return { guard, dialog };
}
